<div class="modal-body">
    <div class="fa-3x text-center text-light">
        <i class="fas fa-sync fa-spin"></i>
        <span class="ml-3">Loading</span>
    </div>
</div>